import React from 'react';
import { connect } from 'react-redux';
import { findMatch } from '@/utils/resultsHelper';
import { states } from '@/constants/lifecycle';
import CohortAxisDropdown from '../components/CohortAxisDropdown';
import { cohortAxis, cohortChart } from '../constants';
import { filterableFields, getCohortActiveDictionary } from '../../helper';
import {
  changeCohortVisualisationXAxis,
  changeCohortVisualisationYAxis,
} from '../actions';
import {
  chartReadStatus, filterValidChartQueries,
  filterXAxisFields,
  filterYAxisFields,
} from '../helper';
import { findActiveQuery } from '../../state/shared';

const CohortBoxPlotVariables = ({
  cohort,
  category,
  changeXAxis,
  changeYAxis,
  code,
  xAxis,
  yAxis,
  fields,
}) => {
  const { readStatus } = chartReadStatus(filterValidChartQueries(cohort, cohortChart.BOX_PLOT));

  return (
    <>
      <CohortAxisDropdown
        axis={cohortAxis.X_AXIS}
        value={xAxis}
        fields={filterXAxisFields(fields)}
        onChange={(name, label) => changeXAxis(category, code, cohortChart.BOX_PLOT, name, label)}
        disabled={readStatus === states.PENDING}
      />
      <CohortAxisDropdown
        axis={cohortAxis.Y_AXIS}
        value={yAxis}
        fields={filterYAxisFields(fields)}
        onChange={(name, label) => changeYAxis(category, code, cohortChart.BOX_PLOT, name, label)}
        disabled={readStatus === states.PENDING}
      />
    </>
  );
};

const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
}, ownProps) => {
  const { cohort, query } = findActiveQuery(cohorts, ownProps);
  const chartQuery = findMatch(query.visualisations, ownProps.chartType);
  const dictionary = getCohortActiveDictionary(cohort) || { fields: [] };

  return ({
    cohort,
    queries: cohort.queries || [],
    fields: filterableFields(dictionary.fields),
    xAxis: chartQuery.xAxis.value,
    yAxis: chartQuery.yAxis.value,
  });
};

const mapDispatchToProps = {
  changeXAxis: changeCohortVisualisationXAxis,
  changeYAxis: changeCohortVisualisationYAxis,
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortBoxPlotVariables);
